import styled, { css } from 'styled-components';
import media from '../../../constants/media';

export const InputWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	${media.mobileOnly`
		flex-wrap: wrap;
	`};
`;

export const ButtonWrapper = styled.div`
	margin-left: 1.5rem;

	${media.mobileOnly`
		display: flex;
		justify-content: center;
		width: 100%;
		margin-left: 0;
		margin-top: 1rem;
	`};
`;

export const Wrapper = styled.div``;

export const TableWrapper = styled.div`
	margin-top: 2rem;
`;

export const InputAndDropdownWrapper = styled.div`
	width: 100%;
	position: relative;
`;

export const DropdownWrapper = styled.div`
	position: absolute;
	width: 100%;
	z-index: 1;
`;

export const List = styled.ul`
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
`;

export const Item = styled.li`
	padding: 0.5rem 2.5rem;
	background-color: ${({ theme }) => theme.colors.white};
	list-style-type: none;

	${({ highlighted }) =>
		highlighted &&
		css`
			background-color: ${({ theme }) => theme.colors.grayLight};
		`};
`;

export const LoaderContainer = styled.div`
	margin: 3rem 0;
`;
